import FormStore from "../form";
import HeaderRegister from "../../../../components/header/register";

const MainRegisterStore = () => {
	const options = {
		title: "Minha Empresa",
		subTitle: "Cadastro",
	};

	return (
		<div className="mt-page">
			{/* <div className="flex flex-col h-screen"> */}
			<HeaderRegister title={options.title} subTitle={options.subTitle} />
			{/* <div className="flex-grow  bg-gray-100 p-4">Conteúdo</div>
			<div className="bg-slate-500 p-4 text-white mb-5">Rodapé</div> */}
			<FormStore />
			{/* <footer className="">
				<Footer />
			</footer> */}
		</div>
	);
};

export default MainRegisterStore;
